export default __webpack_public_path__ + "media/images/dashboard/users-4b1ab9be9c971bef55dd5a8b4bf9398e.svg";